import { Fragment } from 'react';
import { splitNoteLinks } from '../lib/noteLinks';

/** A job's notes with their phone numbers and email addresses as links (lib/noteLinks). */
export function LinkedText({ text }: { text: string }) {
  return (
    <>
      {splitNoteLinks(text).map((part, index) =>
        part.href ? (
          <a key={index} href={part.href} className="break-words font-medium text-[color:var(--ck-link)] underline-offset-2 hover:underline">
            {part.text}
          </a>
        ) : (
          <Fragment key={index}>{part.text}</Fragment>
        )
      )}
    </>
  );
}
